import { memo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Popup } from "../../components/Popup";
import { CvvPrepareGate } from "../../components/CvvPrepareGate";
import { SEND_ROUTES } from "../../constants";
import { sendSavedCards } from "../../gallery/sendMock";
import { TransferPage } from "./TransferPage";

/**
 * Gallery inspectable state: Transfer with the funding CVV prepare popup open.
 */
export const CvvPrepareGatePage = memo(() => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(true);
  const card = sendSavedCards[0];

  return (
    <>
      <TransferPage />
      <Popup
        visible={visible}
        onClose={() => {
          setVisible(false);
          navigate(SEND_ROUTES.TRANSFER);
        }}
      >
        <CvvPrepareGate
          ns="send"
          last4={card.last4}
          brand={card.brand}
          onClose={() => {
            setVisible(false);
            navigate(SEND_ROUTES.TRANSFER);
          }}
          onSubmit={() => {
            navigate(SEND_ROUTES.SENDING, { replace: true });
          }}
        />
      </Popup>
    </>
  );
});
